angular.module('autoremind.services')
    .factory('todoService', [
    '$rootScope', '$http', '$timeout', '$window', '$filter', '$enhancedHttp', '$q', 'dialogs',
    function ($rootScope, $http, $timeout, $window, $filter, $enhancedHttp, $q, dialogs) {
        var todoMsg, chosenDate;
        var todoService = {
            loadingIndicator: {
                refCount: 0,
                state: true
            },
            chosenDate: new Date(),
            chosenDateShort: $filter('date')(new Date(), 'yyyy-MM-dd'),
            tasks: {},
            tmpTasksForRollback: {},
            // JACOB: Why are these objects and not arrays?
            todoOptions: {},
            tmpOptions: [],
            needRefreshReports: false,
            refreshRequestInterval: null,
            delayForRefreshRequest: 30000,
            delayForTasksUpdate: 6000,
            todoMessage: false,
            cancelHttpRequest: false,
            clearModel: function () {
                console.log('Clear the model!');
                this.chosenDate = new Date();
                this.chosenDateShort = $filter('date')(this.chosenDate, 'yyyy-MM-dd');
                // TODO: Change to arrays?
                this.tasks = {};
                this.tmpTasksForRollback = {};
                this.todoOptions = {};
                this.todoMessage = false;
                this.destroy();
            },
            destroy: function () {
                if (this.refreshRequestInterval) {
                    $timeout.cancel(this.refreshRequestInterval);
                    this.refreshRequestInterval = null;
                }
                if (this.cancelHttpRequest) {
                    this.cancelHttpRequest.resolve();
                }
            },
            getTodoMsg: function () {
                return this.todoMsg;
            },
            getDate: function () {
                return this.chosenDate;
            },
            loadTasksByDay: function (date) {
                date = $filter('date')(date, 'yyyy-MM-dd');
                this.initTodoTasks(date);
            },
            initTodoTasks: function (date) {
                this.setMsg(false);
                if (this.refreshRequestInterval) {
                    $timeout.cancel(this.refreshRequestInterval);
                    this.refreshRequestInterval = null;
                }
                if (this.cancelHttpRequest) {
                    console.log('cancel request');
                    this.cancelHttpRequest.resolve();
                }
                this.cancelHttpRequest = $q.defer();
                var self = this;
                //self.chosenDate = date;
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    //url: '/mock/tasks/2016-03-01/',
                    url: '/servlets/todo/tasks/' + date + '/',
                    disableErrorDialog: false,
                    retryBtn: true,
                    timeout: self.cancelHttpRequest.promise
                }, self.loadingIndicator)
                    .then(function (data) {
                    self.addTasksToThisFactory(date, data);
                }, function (error) {
                    // NOTE: On failure the tasksNotDone should not change
                    self.tasksUpdater(self.chosenDateShort, self.delayForRefreshRequest);
                });
            },
            calculateTasksNotDone: function (date) {
                var self = this;
                var dateTasks = self.tasks[date];
                dateTasks.countNotDoneTasks = 0;
                dateTasks.countNotDonePatientTasks = 0;
                var patients = dateTasks.patients;
                if (patients !== undefined) {
                    Object.keys(patients).map(function (key) {
                        var tasks = patients[key].data;
                        tasks.forEach(function (task) {
                            console.log(task);
                            if (!task.isDone) {
                                dateTasks.countNotDoneTasks++;
                                dateTasks.countNotDonePatientTasks++;
                                //console.log('data.countNotDoneTasks=' + data.countNotDoneTasks);
                            }
                            // TODO: Update task.state?
                        });
                    });
                }
                // TODO: Also count other and business tasks
            },
            addTasksToThisFactory: function (date, data) {
                var self = this;
                //                    self.tasks[date] = [];
                //self.tasks[date].countNotDoneTasks = 0;
                self.cancelHttpRequest = false;
                if (data && data.hasOwnProperty('taskGenerator')) { // NOTE: if no data then report error before this function
                    self.noTasksGenerated(date, data.taskGenerator);
                    self.tasks[date] = [];
                    self.calculateTasksNotDone(date);
                    return;
                }
                // TODO: Refactor to traverse data.tasks and compare with current tasks and only update, add new and delete if not in data
                // TODO: Move copy for rollback to only copy before saving and remove old copy on successful save
                $timeout(function () {
                    if (!data.hasOwnProperty('tasks')) {
                        console.log('Error: no task data - we should at least get an empty list!');
                    }
                    else if (data.tasks.length == 0) {
                        self.noTasksGenerated(date, 'empty');
                        // TODO: check if date is today
                    }
                    else {
                        self.conversionOfTasks(data.tasks, date);
                        //this.filteredData = $filter('todoDataFilter')(data.tasks);
                        //self.tasks[date] = this.filteredData;
                        //self.tmpTasksForRollback[date] = angular.copy(self.tasks[date]);
                        self.tasksUpdater(self.chosenDateShort, self.delayForRefreshRequest);
                    }
                });
            },
            tasksUpdater: function (date, delay) {
                console.log('Tasks Updater, date: ' + date + ', delay: ' + delay, 'dialog: ', dialogs);
                var self = this;
                if (this.refreshRequestInterval) {
                    return;
                }
                this.refreshRequestInterval = $timeout(function () {
                    self.initTodoTasks(date);
                }, delay);
            },
            rollbackTasksStateAfterError: function () {
                var self = this;
                $timeout(function () {
                    self.tasks[self.chosenDateShort] = angular.copy(self.tmpTasksForRollback[self.chosenDateShort]);
                });
            },
            // TODO: Extend this to also support saving business tasks (when/if we expand to have such tasks)
            markAllTasksBySubgroupAndSave: function (subgroup, state) {
                if (this.tasks[this.chosenDateShort].patients.hasOwnProperty(subgroup)) {
                    var tmpDataForSendToServer = [];
                    for (var i in this.tasks[this.chosenDateShort].patients[subgroup].data) {
                        this.tasks[this.chosenDateShort].patients[subgroup].data[i].isDone = state;
                        tmpDataForSendToServer.push({
                            taskId: this.tasks[this.chosenDateShort].patients[subgroup].data[i].id,
                            taskState: state
                        });
                    }
                    return this.saveTasksChanges(tmpDataForSendToServer);
                }
            },
            markSubGroup: function (subgroup) {
                if (typeof this.tasks[this.chosenDateShort].patients[subgroup] === 'undefined' || !typeof this.tasks[this.chosenDateShort].patients[subgroup].hasOwnProperty('data')) {
                    return;
                }
                for (var i in this.tasks[this.chosenDateShort].patients[subgroup].data) {
                    if (!this.tasks[this.chosenDateShort].patients[subgroup].data[i].isDone) {
                        this.tasks[this.chosenDateShort].patients[subgroup].isChecked = false;
                        return;
                    }
                }
                this.tasks[this.chosenDateShort].patients[subgroup].isChecked = true;
            },
            saveTasksChanges: function (tasks) {
                var self = this;
                if (tasks.lenght < 1) {
                    self.rollbackTasksStateAfterError();
                    return $q.reject();
                }
                var deferred = $q.defer();
                $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/todo/',
                    disableErrorDialog: false,
                    errorMessage: 'Error saving task states',
                    data: {
                        tasks: tasks
                    }
                }, { refCount: 0, state: true })
                    .then(function (data) {
                    // TODO: Enable updating tasks when backend is fixed
                    //self.addTasksToThisFactory(self.chosenDate, data);
                    deferred.resolve();
                }, function (error) {
                    self.rollbackTasksStateAfterError();
                    deferred.resolve();
                });
                return deferred.promise;
            },
            noTasksGenerated: function (date, messageType) {
                var self = this;
                switch (messageType) {
                    case 'empty':
                        this.setMsg('taskGenerator_emptyToday');
                        break;
                    case 'skipped':
                        this.setMsg('taskGenerator_skipped');
                        break;
                    case 'pending':
                        self.setMsg('taskGenerator_pending');
                        this.tasksUpdater(date, this.delayForTasksUpdate);
                        break;
                    default:
                        this.setMsg('taskGenerator_skipped');
                }
            },
            setMsg: function (message) {
                this.todoMessage = message;
            },
            getTodoSettings: function () {
                return this.todoOptions;
            },
            loadOptions: function () {
                console.log('Loading options');
                var self = this;
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/todo/settings/',
                    errorMessage: 'Failed getting todo-list settings from server',
                    disableErrorDialog: false
                }, this.loadingIndicator)
                    .then(function (response) {
                    self.todoOptions = response.options;
                    if (response.hasOwnProperty('optionsNew') && response.optionsNew) {
                        console.log('options new');
                        self.optionsNew = true;
                    }
                    else {
                        self.optionsNew = false;
                        self.someOptionNew = false;
                        response.options.forEach(function (option) {
                            if (option.hasOwnProperty('optionNew') && option.optionNew) { // Note: optionNew is not plural
                                console.log('some new options');
                                self.someOptionNew = true;
                            }
                        });
                    }
                    return response;
                });
            },
            saveSettings: function (options) {
                var self = this;
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/todo/settings/',
                    errorMessage: 'Failed saving todo-list settings',
                    disableErrorDialog: false,
                    data: {
                        options: options
                    }
                }, this.loadingIndicator)
                    .then(function (response) {
                    // Replace with options from server in case of changes
                    self.todoOptions = options;
                    self.optionsNew = false; // This should never be true after first save
                    self.someOptionNew = false;
                    options.forEach(function (option) {
                        if (option.hasOwnProperty('optionNew') && option.optionsNew) { // Note: optionNew is not plural
                            self.someOptionNew = true;
                        }
                    });
                    return response;
                });
            },
            conversionOfTasks: function (tasksData, date) {
                if (this.tasks === undefined || this.tasks[date] === undefined) {
                    this.tasks[date] = {
                        tasks: tasksData,
                        patients: {},
                        other: [],
                        countNotDoneTasks: 0,
                        countNotDonePatientTasks: 0,
                        countNotDoneBusiness: 0,
                        countNotDoneOther: 0
                    };
                }
                else {
                    this.tasks[date].countNotDoneTasks = 0;
                }
                var self = this;
                var tmpPatients = [];
                //console.log('filter', data)
                tasksData.forEach(function (item) {
                    var parameterString = '';
                    if (item.parameters !== undefined && item.parameters.length > 0) {
                        // Convert parameters to string of values seperated by | for the i18n filter to use in the view
                        for (var i = 0; i < item.parameters.length; i++) {
                            parameterString += '|' + item.parameters[i];
                        }
                    }
                    // TODO: Move counting not done to use calculateTasksNotDone()
                    if (item.taskState !== 'done') {
                        self.tasks[date].countNotDoneTasks++;
                    }
                    if (item.taskType === 'other') {
                        if (item.taskState === 'done') {
                            item.isDone = true;
                        }
                        else {
                            self.tasks[date].countNotDoneOther++;
                            item.isDone = false;
                        }
                        self.tasks[date].other.push(item);
                        return;
                    }
                    else if (item.taskType === 'business') {
                        if (item.taskState !== 'done') {
                            self.tasks[date].countNotDoneBusiness++;
                        }
                    }
                    //console.log(Object.keys(sortedData.patients), Object.keys(sortedData.patients).indexOf(item.personId.toString()), item.personId.toString())
                    var patientKey = item.personId.toString() + '-' + item.appointmentId.toString();
                    var patients = self.tasks[date].patients;
                    if (Object.keys(patients).indexOf(patientKey) === -1) {
                        patients[patientKey] = {
                            task: item,
                            appointmentTime: item.appointmentTime,
                            firstName: item.firstName,
                            middleName: item.middleName,
                            lastName: item.lastName,
                            personId: item.personId,
                            patientKey: patientKey,
                            isChecked: (item.taskState === 'done'),
                            data: [{
                                    id: item.taskId,
                                    key: item.taskKey,
                                    type: item.taskType,
                                    state: item.taskState,
                                    parameterString: parameterString,
                                    isDone: (item.taskState === 'done')
                                }]
                        };
                    }
                    else {
                        // Already one task added for patient object - so just add to it's task list (data) 
                        var patient = patients[patientKey];
                        // Check if task already exists so we only update it's state (to avoid popping of UI)
                        var exists = false;
                        for (var i in patient.data) {
                            var task = patient.data[i];
                            if (patient.data[i].id === item.taskId) {
                                exists = true;
                                // Update existing task
                                patient.data[i];
                                patient.data[i].state = item.taskState;
                                patient.data[i].isDone = item.taskState === 'done';
                                patient.data[i].parameterString = parameterString;
                                break;
                            }
                        }
                        if (!exists) {
                            patient.data.push({
                                id: item.taskId,
                                key: item.taskKey,
                                type: item.taskType,
                                state: item.taskState,
                                parameterString: parameterString,
                                isDone: item.taskState === 'done'
                            });
                        }
                        // Update group checkbox - if at least one is not done then don't set overall checkbox
                        patient.isChecked = true;
                        for (var i in patient.data) {
                            if (!patient.data[i].isDone) {
                                patient.isChecked = false;
                                break;
                            }
                        }
                    }
                });
                self.tmpTasksForRollback[date] = angular.copy(self.tasks[date]);
            }
        };
        $rootScope.$on('event:auth-logout', function () {
            todoService.clearModel();
        });
        return todoService;
    }
]);
//# sourceMappingURL=todo.services.js.map